import { ENTRIES_LOADED } from '../constants';
import {makeInitialState, index} from './utils'

const initialState = {
    playlistSOTW: null,
    contrarianPagesTitles: [],
    freeToDownloadSongs: {},
    freeTracks: {},
    loaded: false,
    freeAlbums: {}
};

export default function update(state = initialState, action) {
    switch (action.type) {
        case ENTRIES_LOADED:
            if(action.entries.commonValues) return Object.assign(state, {loaded: true}, action.entries.commonValues);
            break;
    }
    return state;
}
